import React from 'react'
import { Grid, makeStyles, Radio } from '@material-ui/core'
import DisplayText from '../../../components/Texts/DisplayText'
import { nodata } from '../../../variables/texts'
import Heading from '../../../components/Texts/Heading'
import { blueGrey } from '@material-ui/core/colors'

const useStyles = makeStyles(theme => ({
    root:{
        border:`1px solid ${blueGrey[100]}`,
        borderRadius:4,
        padding:'8px 16px',
        paddingLeft:2,
        
        '&:hover':{
            cursor:'pointer'
        }
    }
}))

const PaymentOption = props => {

    const {selected, onChange, label, image, content} = props
    const classes = useStyles()


    return(
        <div className={classes.root}>
            <Grid container alignItems='center' onClick={onChange}>
                <Grid item>
                    <Radio checked={selected} />
                </Grid>
                <Grid item xs>
                    <DisplayText>{label ? label : nodata}</DisplayText>
                </Grid>
                {image ? (
                    <Grid item>
                        <img {...image} />
                    </Grid>
                ):null}
            </Grid>
            {content}
        </div>
    )
}

export default PaymentOption